import React from 'react';

function CheckBoxField({ id, name, label, isRequired, updateFieldData, className }) {
  const onNameChange = (e) => {
    updateFieldData(id, { name: e.target.value });
  };

  const onLabelChange = (e) => {
    updateFieldData(id, { label: e.target.value });
  };

  const onIsRequiredChange = (e) => {
    updateFieldData(id, { isRequired: e.target.checked });
  };

  return (
    <div className={className}>
      <div className="flex flex-col space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Label</label>
            <input
              type="text"
              value={label}
              onChange={onLabelChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Name (ID)</label>
            <input
              type="text"
              value={name}
              onChange={onNameChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
        </div>

        <div className="flex items-center">
          <input
            id={`required-${id}`}
            type="checkbox"
            checked={isRequired}
            onChange={onIsRequiredChange}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
          />
          <label htmlFor={`required-${id}`} className="ml-2 block text-sm text-gray-700">
            Required field
          </label>
        </div>
      </div>
    </div>
  );
}

export default CheckBoxField;